import React from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "@whatslly/ui-components/v2/BaseElements/Switch";
import styles from "./sharedStyles.module.scss";

interface NotifyInviterOnSidecarEventsSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const NotifyInviterOnSidecarEventsSwitch: React.FC<NotifyInviterOnSidecarEventsSwitchProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.switchTextContainer}>
      <Switch checked={value} onChange={(e) => onChange(e.target.checked)} testId="notify-inviter-on-device-events" />
      <span>{t("user_management.invite_user_modal.notify_inviter_on_sidecar_events")}</span>
    </div>
  );
};
